import { render } from "./MemberMaxCap.vue?vue&type=template&id=b72de210&scoped=true"
import script from "./MemberMaxCap.vue?vue&type=script&lang=js"
export * from "./MemberMaxCap.vue?vue&type=script&lang=js"

import "./MemberMaxCap.vue?vue&type=style&index=0&id=b72de210&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b72de210"]])

export default __exports__